<template>
  <div :class="headerbg" class="app-header header-shadow">
    <!-- <div class="logo-src"/> -->
    <div class="app-header__content">
      <div class="app-header-left"></div>
      <SearchBox v-if="showRole" style="width: 500px" />
      <div class="app-header-right">
        <HeaderDots />
        <!-- TODO: find the right way to solve the userState value as null when the user is not logged in -->
        <UserArea v-if="$store.state.userState" />
      </div>
    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button
          type="button"
          class="hamburger close-sidebar-btn hamburger--elastic"
          v-bind:class="{ 'is-active': isOpen }"
          @click="toggleMobile('closed-sidebar-open')"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
    <div class="app-header__menu">
      <span>
        <b-button
          class="btn-icon btn-icon-only"
          variant="primary"
          size="sm"
          v-bind:class="{ active: isOpenMobileMenu }"
          @click="toggleMobile2('header-menu-open')"
        >
          <div class="btn-icon-wrapper">
            <font-awesome-icon icon="ellipsis-v" />
          </div>
        </b-button>
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import SearchBox from './Header/SearchBox'
import MegaMenu from './Header/MegaMenu'
import HeaderDots from './Header/HeaderDots'
import UserArea from './Header/HeaderUserArea'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faEllipsisV)
export default {
  name: 'Header',
  components: {
    SearchBox,
    MegaMenu,
    HeaderDots,
    UserArea,
    'font-awesome-icon': FontAwesomeIcon,
  },
  data() {
    return {
      isAdmin: null,
      rol: null,
      isOpen: false,
      isOpenMobileMenu: false,
    }
  },
  props: {
    headerbg: String,
  },
  computed: {
    showRole() {
      if (
        this.$store.state.userLogged.roles &&
        this.$store.state.userLogged.roles.length > 0
      ) {
        if (
          this.$store.state.userLogged.roles[0].name === 'ADMIN' ||
          this.$store.state.userLogged.roles[0].name === 'EMPLOYEE'
        ) {
          return true
        } else {
          return false
        }
      }
    },
  },
  methods: {
    toggleMobile(className) {
      const el = document.body
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },

    toggleMobile2(className) {
      const el = document.body
      this.isOpenMobileMenu = !this.isOpenMobileMenu

      if (this.isOpenMobileMenu) {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/Layout/Components/Header.vue